module.exports = __webpack_public_path__ + "h5/img/test.9cb3e5a2.jpg";